import { TypographyXSmallMuted } from '@/components/ui/typography.jsx'

export const LegalApproval = () => {
    return (
        <TypographyXSmallMuted className="leading-4 text-center">
            By continuing you agree to our
            <a href="https://upspring.ai/terms-of-use" target="_blank" className="underline ml-1">Terms of use</a>
            <br />
            <span className="mx-1 mt-1 inline-block">and</span>
            <a href="https://upspring.ai/privacy-policy" target="_blank" className="underline">Privacy Policy</a>
        </TypographyXSmallMuted>
    )
}